import { render } from "./productdetails.vue?vue&type=template&id=3e6cb7c6"
import script from "./productdetails.vue?vue&type=script&lang=js"
export * from "./productdetails.vue?vue&type=script&lang=js"

import "./productdetails.vue?vue&type=style&index=0&id=3e6cb7c6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__